import React from "react";
import { css } from "styled-components/macro"; //eslint-disable-line
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./components/Home.js";
import WhoWeAre from "./components/WhoWeAre/WhoWeAre.js";
import WhatWeDo from "./components/WhatWeDo/WhatWeDo.js";
import Techstack from "./components/Techstack/Techstack.js";
import ContactUs from "./components/Contact/ContactUs.js";
import Footer from "./components/Footer/Footer.js";
import HomePagePDF from "./components/PDFLayout/HomePagePDF.js";
import Techstackpdf from "./components/Techstack/Techstackpdf.js";
import DedicatedTeam from "./components/WhatWeDo/components/DedicatedTeam.js";
import RealEstates from "./components/WhatWeDo/components/RealEstates.js";
import AppSupport from "./components/WhatWeDo/components/AppSupport.js";
import Cloud from "./components/WhatWeDo/components/Cloud.js";
import DigitalService from "./components/WhatWeDo/components/DigitalService.js";
import ProductEng from "./components/WhatWeDo/components/ProductEng.js";
import Career from "./components/Career/Career.js";
import ApiIntegration from "./components/WhatWeDo/components/ApiIntegration.js";
import ApiDevelopment from "./components/WhatWeDo/components/ApiDevelopment.js";
import LocationIntegration from "./components/WhatWeDo/components/ThirdPartyApi/LocationIntegration.js";
import RealEstateIntegration from "./components/WhatWeDo/components/ThirdPartyApi/RealEstateIntegration.js";
import DocumentIntegration from "./components/WhatWeDo/components/ThirdPartyApi/DocumentIntegration.js";
import AccountingIntegration from "./components/WhatWeDo/components/ThirdPartyApi/AccountingIntegration.js";
import MessagingIntegration from "./components/WhatWeDo/components/ThirdPartyApi/MessagingIntegration.js";
import ApplicationDevelopment from "./components/WhatWeDo/components/ApplicationDevelopment.js";
import IdentityIntegration from "./components/WhatWeDo/components/ThirdPartyApi/IdentityIntegration.js";
import RealEstatePagePDF from "./components/PDFLayout/RealEstatePagePDF.js";
import ThirdPartyIntegrationPDF from "./components/PDFLayout/ThirdPartyIntegrationPDF.js";
import PDF from "./components/PDFLayout/PDF.js";
import CustomerIdentityManagement from "./components/WhatWeDo/components/CustomerIdentityManagement.js";
import OurServices from "./components/OurServices/OurServices.js";
import ApplicationFramework from "./components/WhatWeDo/components/ApplicationFramework.js";
import AppInBoxPDF from "./components/PDFLayout/AppInBoxPDF.js";
import DigitalTransformationPDF from "./components/PDFLayout/DigitalTransformationPDF.js";
import CloudPagePdf from "./components/PDFLayout/CloudPagePDF.js";
import CustomerIdenetityManagementPDF from "./components/PDFLayout/CustomerIdenetityManagementPDF.js";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/who-we-are" element={<WhoWeAre />} />
        <Route path="/our-services" element={<OurServices />} />
        <Route path="/what-we-do" element={<WhatWeDo />} />
        <Route path="/techstack" element={<Techstack />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/footer" element={<Footer />} />
        <Route path="/home-page-pdf" element={<HomePagePDF />} />
        <Route path="/realestate-page-pdf" element={<RealEstatePagePDF />} />
        <Route
          path="/third-party-api-integration-pdf"
          element={<ThirdPartyIntegrationPDF />}
        />
        <Route path="/App-in-box-pdf" element={<AppInBoxPDF />} />
        <Route
          path="/digital-transformation-pdf"
          element={<DigitalTransformationPDF />}
        />
        <Route
          path="/identity-access-integration-pdf"
          element={<CustomerIdenetityManagementPDF />}
        />
        <Route path="/cloud-services-pdf" element={<CloudPagePdf />} />
        <Route
          path="what-we-do/real-estate-software-company"
          element={<RealEstates />}
        />
        <Route path="what-we-do/cloud-services" element={<Cloud />} />
        <Route
          path="what-we-do/customer-identity-and-access-management"
          element={<CustomerIdentityManagement />}
        />
        <Route
          path="what-we-do/digital-transformation-services"
          element={<DigitalService />}
        />
        <Route
          path="what-we-do/application-framework"
          element={<ApplicationFramework />}
        />
        <Route
          path="our-services/application-development"
          element={<ApplicationDevelopment />}
        />
        <Route
          path="our-services/api-development"
          element={<ApiDevelopment />}
        />
        <Route
          path="our-services/application-support"
          element={<AppSupport />}
        />
        <Route
          path="our-services/third-party-api-integrations"
          element={<ApiIntegration />}
        />
        <Route
          path="our-services/dedicated-development-teams"
          element={<DedicatedTeam />}
        />
        <Route
          path="our-services/product-engineering"
          element={<ProductEng />}
        />
        <Route
          path="our-services/third-party-api-integrations/location-address-integration"
          element={<LocationIntegration />}
        />
        <Route
          path="our-services/third-party-api-integrations/identity-access-integration"
          element={<IdentityIntegration />}
        />
        <Route
          path="our-services/third-party-api-integrations/real-estate-property-database"
          element={<RealEstateIntegration />}
        />
        <Route
          path="our-services/third-party-api-integrations/document-automation"
          element={<DocumentIntegration />}
        />
        <Route
          path="our-services/third-party-api-integrations/accounts-and-payment"
          element={<AccountingIntegration />}
        />
        <Route
          path="our-services/third-party-api-integrations/messaging-communication"
          element={<MessagingIntegration />}
        />
        <Route path="/techstackpdf" element={<Techstackpdf />} />
        <Route path="/pdf" element={<PDF />} />
      </Routes>
    </Router>
  );
};
export default App;
